export default "__VITE_ASSET__BjyxV8dr__"